import { lazy } from 'react';


export const EditStudent = lazy(() => import('./EditStudent'));
